import { useEffect, useState } from 'react';
import { WifiOff, Loader2, Lock } from 'lucide-react';
import { subscribeOnlineStatus, queueLength, getOnlineStatus } from '../lib/offlineQueue';
import { subscribeReadOnly, isReadOnly } from '../lib/readOnlyMode';

export function useOnlineStatus() {
    const [online, setOnline] = useState(getOnlineStatus());
    useEffect(() => subscribeOnlineStatus(setOnline), []);
    return online;
}

export function useReadOnly() {
    const [ro, setRo] = useState(isReadOnly());
    useEffect(() => subscribeReadOnly(setRo), []);
    return ro;
}

export function OfflineBanner() {
    const [online, setOnline] = useState(getOnlineStatus());
    const [pending, setPending] = useState(queueLength());
    const [readOnly, setReadOnly] = useState(isReadOnly());

    useEffect(() => {
        const unsub = subscribeOnlineStatus((value) => {
            setOnline(value);
            setPending(queueLength());
        });
        const unsubRo = subscribeReadOnly(setReadOnly);
        const t = setInterval(() => setPending(queueLength()), 5000);
        return () => { unsub(); unsubRo(); clearInterval(t); };
    }, []);

    if (online && pending === 0) return null;
    return <div data-testid="offline-banner" />;
}

export function OnlinePulse({ size = 8 }) {
    const online = useOnlineStatus();
    return (
        <span
            className={`inline-block rounded-full ${online ? 'bg-emerald-500' : 'bg-red-500'}`}
            style={{ width: size, height: size }}
            title={online ? 'En ligne' : 'Hors ligne'}
            data-testid="online-pulse"
        />
    );
}
